export const defaultSerializer = {
  serialize: (value)=>JSON.stringify(value),
  deserialize: (value)=>JSON.parse(value)
};
export const StatusCodeMap = {
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  UNAUTHORIZED: 401,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  UNSUPPORTED_MEDIA_TYPE: 415,
  GENERIC_ERROR: 500
};
export class SRPCError extends Error {
  code;
  constructor(message, code){
    super(message);
    this.code = code;
    this.__BRAND__ = "SRPCError";
    this.name = "SRPCError";
  }
  __BRAND__;
}
//# sourceMappingURL=index.js.map